import { getDeviceType } from './getDeviceType';
// import gdp from 'gio-webjs-sdk-cdp';
// import gdp from 'gio-webjs-sdk-cdp/gdp-full';
import store from '@/store';
const config = {
    Android: {
        dev: {
            accountId: "b215483a826f0aca",
            dataSourceId: "865a75a6ad2bd64f",
            host: "tracking-uat.immotors.com"
        },
        prod: {
            accountId: "aeafabe7322c3ab8",
            dataSourceId: "95b076af128fb3f6",
            host: "tracking.immotors.com"
        }
    },
    iOS: {
        dev: {
            accountId: "b215483a826f0aca",
            dataSourceId: "b1a9655992f2d253",
            host: "tracking-uat.immotors.com"
        },
        prod: {
            accountId: "aeafabe7322c3ab8",
            dataSourceId: "94ff8d6107332d96",
            host: "tracking.immotors.com"
        }
    }

}
const deviceType = getDeviceType();
const deviceTypeMode = config[deviceType == "unknown" ? "Android" : deviceType];
const { accountId, dataSourceId, host } = process.env.VUE_APP_MODE == 'prod' ? deviceTypeMode.prod : deviceTypeMode.dev

export default {
    init() {
        (function (window, document, script, src, namespace) {
            window[namespace] = window[namespace] || function () {
                (window[namespace].q = window[namespace].q || []).push(arguments)
            };
            script = document.createElement('script');
            let tag = document.getElementsByTagName('script')[0];
            script.async = true;
            script.src = src;
            tag.parentNode.insertBefore(script, tag);
        })(window, document, 'script', 'https://assets.giocdn.com/sdk/cdp/gio.js', 'gdp');

        window._gr_ignore_local_rule = process.env.NODE_ENV == 'development';
        window.gdp('init', accountId, dataSourceId, {
            host,
            version: '1.0.0',
            debug: process.env.VUE_APP_MODE !== 'prod' && process.env.NODE_ENV !== 'development',
            autotrack: false,
            compress: process.env.VUE_APP_MODE == 'prod'
        });

        window.gdp('send');


    },

    track(properties, eventId = "AIcreate_click") {
        var data = {
            pageType_var: "AI创作",
            pageName_var: "AI创作",
            ReportedInfo_var: "操作方式",
            RequestResult_var: "成功",
            VersionType_var: store.state.versionType,
            VehicleType_var: store.state.vehicleType,
            ...properties
        }
        window.gdp('track', eventId, data);
    }
}